import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { client } from "./apolloClient";

// Lazy retry with optional retry count and delay
const lazyRetry = (importFn, retries = 3, delay = 1000) =>
  new Promise((resolve, reject) => {
    function attempt(n) {
      importFn()
        .then(resolve)
        .catch((error) => {
          if (n <= 1) return reject(error);
          setTimeout(() => attempt(n - 1), delay);
        });
    }
    attempt(retries);
  });

// Lazy-load route components
const AboutUs = lazy(() => import(/* webpackChunkName: "about" */ "./about/about"));
const OurWork = lazy(() => import(/* webpackChunkName: "ourwork" */ "./ourwork/ourwork"));
const Donors = lazy(() => import(/* webpackChunkName: "donors" */ "./donors/donors"));
const Error404 = lazy(() => import(/* webpackChunkName: "error" */ "./error/404"));
const Login = lazy(() => import(/* webpackChunkName: "login" */ "./login/login"));
const Donate = lazy(() => import(/* webpackChunkName: "donate" */ "./donate/donate"));
const Team = lazy(() => import(/* webpackChunkName: "team" */ "./team/team"));
const ContactUs = lazy(() => import(/* webpackChunkName: "contact" */ "./contactus/contact"));
const PrisonVoicePage = lazy(() => import(/* webpackChunkName: "prisonvoices" */ "./prisonvoices/prisonvoices"));
const FAQs = lazy(() => import(/* webpackChunkName: "faqs" */ "./faqs/faqs"));
const Careers = lazy(() => import(/* webpackChunkName: "careers" */ "./career/career"));
const Resources = lazy(() => import(/* webpackChunkName: "resources" */ "./resources/resources"));
const PAARMap = lazy(() => lazyRetry(() => import(/* webpackChunkName: "map" */ "./mapping/google")));
const Report = lazy(() => import(/* webpackChunkName: "report" */ "./report/report"));
const Home = lazy(() => import(/* webpackChunkName: "home" */ "./home/home"));
const Article = lazy(() => import(/* webpackChunkName: "article" */ "./article/article"));
const TermsAndConditions = lazy(() => import(/* webpackChunkName: "terms" */ "./tc_and_pp/tc_and_pp"));
const Privacy = lazy(() => import(/* webpackChunkName: "privacy" */ "./tc_and_pp/policy"));
const PdfPage = lazy(() => import(/* webpackChunkName: "pdf" */ "./rti/pdfPage"));

export default function Main() {
  return (
    <ApolloProvider client={client}>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/who-we-are" element={<AboutUs />} />
          <Route path="/our-work" element={<OurWork />} />
          <Route path="/error404" element={<Error404 />} />
          <Route path="/login" element={<Login />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/prisonvoices" element={<PrisonVoicePage />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/career" element={<Careers />} />
          <Route path="/paar-media" element={<Resources />} />
          <Route path="/map" element={<PAARMap />} />
          <Route path="/pdf" element={<PdfPage />} />
          <Route path="/our-supporters" element={<Donors />} />
          <Route path="/report" element={<Report />} />
          <Route path="/article" element={<Article />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/home" element={<Home />} />
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </Suspense>
    </ApolloProvider>
  );
}